import React, { PropTypes } from 'react';
import _ from 'lodash';

import { icon } from './../../icons/icons';

const General = (props) => {
    const { widgetsTypesOnPage, widgetsTemplates, actions } = props;

    // sprawdza czy na stronie sa dodane widgety wymagajace wybrania wartosci
    const checkForValuedWidgets = () => {
        for (let i = 0; i < widgetsTypesOnPage.length; i++) {
            const widget = widgetsTemplates[widgetsTypesOnPage[i]];
            if (widget.hasValue) {
                return true;
            }
        }
    };

    const addWidget = (e) => {
        actions.addWidgetToPage(e.target.getAttribute('data-widget'));
    };
    return (
        <div className="widgets">
            <h3 className="widgets__header">Choose widget</h3>
            {_.map(widgetsTemplates, (widget) =>
                <div key={widget.id} className="widget">
                    <span className="widget__icon">
                        { icon.list() }
                    </span>
                    {widget.type}
                    {
                        (_.includes(widgetsTypesOnPage, widget.id) || (checkForValuedWidgets() && widget.hasValue)) ?
                        null : (<div className="widget__add" data-widget={widget.id} onClick={addWidget}>+</div>)
                    }
                </div>
            )}
        </div>
    );
};

General.propTypes = {
    widgetsTypesOnPage: PropTypes.array.isRequired,
    widgetsTemplates: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default General;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Tools/General.jsx